export default "__VITE_ASSET__HJQtW18L__"